// heat chart data generator
function generateDataHeatMap(count, yrange) {
  let i = 0
  const series = []
  while (i < count) {
    const x = `w${(i + 1).toString()}`
    const y = Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min

    series.push({
      x,
      y
    })

    i++
  }
  return series
}

// colors
const chartColors = {
  column: {
    series1: '#5bc0de',
    series2: '#d2b0ff',
    bg: '#f8d3ff'
  },
  success: {
    shade_100: '#7eefc7',
    shade_200: '#06774f'
  },
  donut: {
    series1: 'var(--utility-brand-500)',
    series2: 'var(--utility-pink-500)',
    series3: 'var(--utility-purple-500)',
    series4: 'var(--utility-yellow-500)',
    series5: 'var(--utility-blue-500)'
  },
  area: {
    series3: 'var(--utility-brand-500)',
    series2: 'var(--utility-pink-500)',
    series1: 'var(--utility-purple-500)'
  },
  trackColor: 'var(--bg-secondary)',
  gradientColors: {
    primary: 'var(--utility-brand-500)',
    pink: 'var(--utility-pink-500)',
    info: 'var(--utility-purple-500)'
  }
}
const gradientFillObject = {
  type: 'gradient',
  gradient: {
    type: 'radial',
    shadeIntensity: 1,
    opacityFrom: 1,
    opacityTo: 1,
    stops: [0, 70, 100],
    colorStops: [
      {
        offset: 0,
        color: chartColors.gradientColors.info,
        opacity: 1
      },
      {
        offset: 70,
        color: chartColors.gradientColors.pink,
        opacity: 1
      },
      {
        offset: 100,
        color: chartColors.gradientColors.primary,
        opacity: 1
      }
    ]
  }
}

export default {
  lineChartSimple: {
    series: [
      // {
      //   data: [
      //     280, 200, 220, 180, 270, 250, 70, 90, 200, 150, 160, 100, 150, 100, 50
      //   ]
      // }
    ],
    chartOptions: {
      chart: {
        zoom: {
          enabled: false
        },
        toolbar: {
          show: false
        }
      },
      markers: {
        strokeWidth: 7,
        strokeOpacity: 1
        // strokeColors: [$themeColors.light],
        // colors: [$themeColors.warning],
      },
      // colors: [$themeColors.warning],
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: 'straight'
      },
      grid: {
        xaxis: {
          lines: {
            show: true
          }
        }
      },
      tooltip: {
        custom(data) {
          return `${'<div class="px-1 py-50"><span>'}${data.series[data.seriesIndex][data.dataPointIndex]}%</span></div>`
        }
      },
      xaxis: {
        categories: [
          // '7/12',
          // '8/12',
          // '9/12',
          // '10/12',
          // '11/12',
          // '12/12',
          // '13/12',
          // '14/12',
          // '15/12',
          // '16/12',
          // '17/12',
          // '18/12',
          // '19/12',
          // '20/12',
          // '21/12'
        ]
      },
      yaxis: {
        // opposite: isRtl,
      }
    }
  },

  lineAreaChart: {
    series: [
      {
        name: 'Appointments',
        data: [31, 40, 28, 51, 42, 37]
      },
      {
        name: 'Renewals',
        data: [7, 16, 4, 20, 19, 9]
      }
    ],
    options: {
      legend: {
        position: 'top',
        horizontalAlign: 'left',
        offsetX: 0,
        labels: {
          colors: 'var(--text-secondary)'
        }
      },
      chart: {
        type: 'line',
        zoom: {
          enabled: false
        },
        toolbar: {
          show: false
        }
      },
      grid: {
        show: false,
        xaxis: {
          lines: {
            show: false
          }
        },
        yaxis: {
          lines: {
            show: false
          }
        },
        padding: {
          left: 10,
          right: 0,
          bottom: -9
        }
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: 'smooth'
      },
      xaxis: {
        categories: ['May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct'],
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false
        },
        labels: {
          style: {
            colors: 'var(--text-secondary)'
          }
        }
      },
      yaxis: {
        labels: {
          offsetX: -15,
          style: {
            colors: 'var(--text-secondary)'
          }
        }
      },
      tooltip: {
        x: {
          format: 'dd/MM/yy HH:mm'
        }
      },
      fill: {
        opacity: 1,
        type: 'solid'
      },
      colors: [chartColors.area.series1, chartColors.area.series3, chartColors.area.series2]
    }
  },

  lineAreaChartSpline: {
    series: [
      {
        name: 'Appointments',
        data: [31, 40, 28, 51, 42, 37]
      },
      {
        name: 'Renewals',
        data: [7, 16, 4, 20, 19, 9]
      }
    ],
    options: {
      legend: {
        position: 'top',
        horizontalAlign: 'left',
        offsetX: 0,
        labels: {
          colors: 'var(--text-secondary)'
        }
      },
      chart: {
        type: 'line',
        zoom: {
          enabled: false
        },
        toolbar: {
          show: false
        }
      },
      grid: {
        show: false,
        xaxis: {
          lines: {
            show: false
          }
        },
        yaxis: {
          lines: {
            show: false
          }
        },
        padding: {
          left: 10,
          right: 0,
          bottom: -9
        }
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: 'smooth'
      },
      xaxis: {
        categories: ['May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct'],
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false
        },
        labels: {
          style: {
            colors: 'var(--text-secondary)'
          }
        }
      },
      yaxis: {
        labels: {
          offsetX: -15,
          style: {
            colors: 'var(--text-secondary)'
          }
        }
      },
      tooltip: {
        x: {
          format: 'dd/MM/yy HH:mm'
        }
      },
      fill: {
        opacity: 1,
        type: 'solid'
      },
      colors: [chartColors.area.series1, chartColors.area.series3, chartColors.area.series2]
    }
  },

  columnChart: {
    series: [
      //   {
      //     name: 'Apple',
      //     data: [90, 120, 55, 100, 80, 125, 175, 70, 88, 180]
      //   },
      //   {
      //     name: 'Samsung',
      //     data: [85, 100, 30, 40, 95, 90, 30, 110, 62, 20]
      //   }
    ],
    chartOptions: {
      chart: {
        stacked: true,
        toolbar: {
          show: false
        }
      },
      noData: {
        text: 'Loading...'
      },
      colors: [chartColors.column.series1, chartColors.column.series2],
      plotOptions: {
        bar: {
          columnWidth: '30%',
          colors: {}
        }
      },
      dataLabels: {
        enabled: false
      },
      legend: {
        show: true,
        position: 'top',
        fontSize: '14px',
        fontFamily: 'Montserrat',
        horizontalAlign: 'left'
      },
      stroke: {
        show: true,
        colors: ['transparent']
      },
      grid: {
        xaxis: {
          lines: {
            show: true
          }
        }
      },
      xaxis: {
        categories: [
          // '7/12',
          // '8/12',
          // '9/12',
          // '10/12',
          // '11/12',
          // '12/12',
          // '13/12',
          // '14/12',
          // '15/12',
          // '16/12'
        ]
      },
      yaxis: {
        // opposite: isRtl,
      },
      fill: {
        opacity: 1
      }
    }
  },

  barChart: {
    series: [
      // {
      //   data: [700, 350, 480, 600, 210, 550, 150]
      // }
    ],
    chartOptions: {
      chart: {
        toolbar: {
          show: false
        }
      },
      noData: {
        text: 'Loading...'
      },
      colors: [chartColors.column.series1, chartColors.column.series2],
      plotOptions: {
        bar: {
          horizontal: true,
          barHeight: '60%',
          endingShape: 'rounded'
        }
      },
      grid: {
        xaxis: {
          lines: {
            show: false
          }
        }
      },
      dataLabels: {
        enabled: false
      },
      xaxis: {
        categories: ['MON, 11', 'THU, 14', 'FRI, 15', 'MON, 18', 'WED, 20', 'FRI, 21', 'MON, 23']
      },
      yaxis: {
        // opposite: isRtl,
      }
    }
  },

  candlestickChart: {
    series: [
      {
        data: [
          {
            x: new Date(1538778600000),
            y: [150, 170, 50, 100]
          },
          {
            x: new Date(1538780400000),
            y: [200, 400, 170, 330]
          },
          {
            x: new Date(1538782200000),
            y: [330, 340, 250, 280]
          },
          {
            x: new Date(1538784000000),
            y: [300, 330, 200, 320]
          },
          {
            x: new Date(1538785800000),
            y: [320, 450, 280, 350]
          },
          {
            x: new Date(1538787600000),
            y: [300, 350, 80, 250]
          },
          {
            x: new Date(1538789400000),
            y: [200, 330, 170, 300]
          },
          {
            x: new Date(1538791200000),
            y: [200, 220, 70, 130]
          },
          {
            x: new Date(1538793000000),
            y: [220, 270, 180, 250]
          },
          {
            x: new Date(1538794800000),
            y: [200, 250, 80, 100]
          },
          {
            x: new Date(1538796600000),
            y: [150, 170, 50, 120]
          },
          {
            x: new Date(1538798400000),
            y: [110, 450, 10, 420]
          },
          {
            x: new Date(1538800200000),
            y: [400, 480, 300, 320]
          },
          {
            x: new Date(1538802000000),
            y: [380, 480, 350, 450]
          }
        ]
      }
    ],
    chartOptions: {
      chart: {
        toolbar: {
          show: false
        }
      },
      xaxis: {
        type: 'datetime'
      },
      yaxis: {
        tooltip: {
          enabled: true
        }
        // opposite: isRtl,
      },
      grid: {
        xaxis: {
          lines: {
            show: true
          }
        }
      },
      legend: {
        show: false
      },
      plotOptions: {
        candlestick: {
          // colors: {
          //   upward: $themeColors.success,
          //   downward: $themeColors.danger,
          // },
        },
        bar: {
          columnWidth: '40%'
        }
      }
    }
  },

  scatterChart: {
    series: [
      {
        name: 'Angular',
        data: [
          [5.4, 170],
          [5.4, 100],
          [6.3, 170],
          [5.7, 140],
          [5.9, 130],
          [7.0, 150],
          [8.0, 120],
          [9.0, 170],
          [10.0, 190],
          [11.0, 220],
          [12.0, 170],
          [13.0, 230]
        ]
      },
      {
        name: 'Vue',
        data: [
          [14.0, 220],
          [15.0, 280],
          [16.0, 230],
          [18.0, 320],
          [17.5, 280],
          [19.0, 250],
          [20.0, 350],
          [20.5, 320],
          [20.0, 320],
          [19.0, 280],
          [17.0, 280],
          [22.0, 300],
          [18.0, 120]
        ]
      },
      {
        name: 'React',
        data: [
          [14.0, 290],
          [13.0, 190],
          [20.0, 220],
          [21.0, 350],
          [21.5, 290],
          [22.0, 220],
          [23.0, 140],
          [19.0, 400],
          [20.0, 200],
          [22.0, 90],
          [20.0, 120]
        ]
      }
    ],
    chartOptions: {
      chart: {
        zoom: {
          enabled: true,
          type: 'xy'
        },
        toolbar: {
          show: false
        }
      },
      grid: {
        xaxis: {
          lines: {
            show: true
          }
        }
      },
      // colors: [$themeColors.warning, $themeColors.primary, $themeColors.success],
      legend: {
        show: true,
        position: 'top',
        horizontalAlign: 'left'
      },
      xaxis: {
        tickAmount: 10,
        labels: {
          formatter(val) {
            return parseFloat(val).toFixed(1)
          }
        }
      },
      yaxis: {
        // opposite: isRtl,
      }
    }
  },

  heatMapChart: {
    series: [
      {
        name: 'SUN',
        data: generateDataHeatMap(24, {
          min: 0,
          max: 60
        })
      },
      {
        name: 'MON',
        data: generateDataHeatMap(24, {
          min: 0,
          max: 60
        })
      },
      {
        name: 'TUE',
        data: generateDataHeatMap(24, {
          min: 0,
          max: 60
        })
      },
      {
        name: 'WED',
        data: generateDataHeatMap(24, {
          min: 0,
          max: 60
        })
      },
      {
        name: 'THU',
        data: generateDataHeatMap(24, {
          min: 0,
          max: 60
        })
      },
      {
        name: 'FRI',
        data: generateDataHeatMap(24, {
          min: 0,
          max: 60
        })
      },
      {
        name: 'SAT',
        data: generateDataHeatMap(24, {
          min: 0,
          max: 60
        })
      }
    ],
    chartOptions: {
      dataLabels: {
        enabled: false
      },
      legend: {
        show: true,
        position: 'bottom'
      },
      colors: ['#7367F0'],
      plotOptions: {
        heatmap: {
          enableShades: false,

          colorScale: {
            ranges: [
              {
                from: 0,
                to: 10,
                name: '0-10',
                color: '#b9b3f8'
              },
              {
                from: 11,
                to: 20,
                name: '10-20',
                color: '#aba4f6'
              },
              {
                from: 21,
                to: 30,
                name: '20-30',
                color: '#9d95f5'
              },
              {
                from: 31,
                to: 40,
                name: '30-40',
                color: '#8f85f3'
              },
              {
                from: 41,
                to: 50,
                name: '40-50',
                color: '#8176f2'
              },
              {
                from: 51,
                to: 60,
                name: '50-60',
                color: '#7367f0'
              }
            ]
          }
        }
      },
      xaxis: {
        labels: {
          show: false
        },
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false
        }
      },
      chart: {
        height: 350,
        type: 'heatmap',
        toolbar: {
          show: false
        }
      }
    }
  },

  donutChart: {
    series: [85, 16, 50, 50],
    chartOptions: {
      legend: {
        show: true,
        position: 'bottom',
        fontSize: '14px',
        fontFamily: 'Montserrat'
      },
      colors: [
        chartColors.donut.series1,
        chartColors.donut.series5,
        chartColors.donut.series3,
        chartColors.donut.series2
      ],
      dataLabels: {
        enabled: true,
        formatter(val) {
          return `${parseInt(val)}%`
        }
      },
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: true,
              name: {
                fontSize: '2rem',
                fontFamily: 'Montserrat'
              },
              value: {
                fontSize: '1rem',
                fontFamily: 'Montserrat',
                formatter(val) {
                  return `${parseInt(val)}%`
                }
              },
              total: {
                show: true,
                fontSize: '1.5rem',
                label: 'Operational',
                formatter() {
                  return '31%'
                }
              }
            }
          }
        }
      },
      labels: ['Operational', 'Networking', 'Hiring', 'R&D'],
      responsive: [
        {
          breakpoint: 992,
          options: {
            chart: {
              height: 380
            },
            legend: {
              position: 'bottom'
            }
          }
        },
        {
          breakpoint: 576,
          options: {
            chart: {
              height: 320
            },
            plotOptions: {
              pie: {
                donut: {
                  labels: {
                    show: true,
                    name: {
                      fontSize: '1.5rem'
                    },
                    value: {
                      fontSize: '1rem'
                    },
                    total: {
                      fontSize: '1.5rem'
                    }
                  }
                }
              }
            },
            legend: {
              show: true
            }
          }
        }
      ]
    }
  },

  radialBarChart: {
    series: [80, 50, 35],
    colors: ['#5bc0de'],
    options: {
      chart: {
        type: 'radialBar',
        parentHeightOffset: 0,
        sparkline: {
          enabled: true
        },
        toolbar: {
          show: false
        }
      },
      plotOptions: {
        radialBar: {
          startAngle: -135,
          endAngle: 225,
          hollow: {
            margin: 0,
            size: '80%',
            background: 'transparent',
            image: undefined,
            imageOffsetX: 0,
            imageOffsetY: 0,
            position: 'front'
          },
          track: {
            // background: '#1e1e1e',
            strokeWidth: '30%',
            margin: 0 // margin is in pixels
          },
          dataLabels: {
            show: true,
            name: {
              offsetY: -10,
              show: false,
              // color: '#888',
              fontSize: '17px'
            },
            value: {
              formatter: function (val) {
                return parseInt(val) + '%'
              },
              // color: 'inherit',
              fontSize: '36px',
              show: true
            }
          }
        }
      },
      fill: {
        type: 'gradient',
        colors: ['#5bc0de'],
        gradient: {
          shade: 'dark',
          type: 'horizontal',
          shadeIntensity: 0.5,
          gradientToColors: ['#945bde'],
          inverseColors: true,
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 100]
        }
      },
      stroke: {
        lineCap: 'round'
      },
      labels: ['Percent']
    }
  },

  halfGauge: {
    options: {
      chart: {
        type: 'radialBar',
        parentHeightOffset: 0,
        sparkline: {
          enabled: true
        }
      },
      plotOptions: {
        radialBar: {
          offsetY: 0,
          startAngle: -90,
          endAngle: 90,
          hollow: { size: '65%' },
          track: {
            strokeWidth: '45%',
            background: '#e7e7e7'
          },
          dataLabels: {
            name: {
              show: false
            },
            value: {
              offsetY: 0,
              fontSize: '20px'
            }
          }
        }
      },
      grid: {
        show: false,
        padding: {
          bottom: 0
        }
      },
      stroke: {
        lineCap: 'round'
      },
      labels: ['Action Score'],
      fill: gradientFillObject
      // responsive: [
      //   {
      //     breakpoint: 1442,
      //     options: {
      //       chart: { height: 140 },
      //       plotOptions: {
      //         radialBar: {
      //           dataLabels: { value: { fontSize: '18px' } },
      //           hollow: { size: '60%' }
      //         }
      //       }
      //     }
      //   },
      //   {
      //     breakpoint: 1370,
      //     options: { chart: { height: 120 } }
      //   },
      //   {
      //     breakpoint: 1280,
      //     options: {
      //       chart: { height: 150 },
      //       plotOptions: {
      //         radialBar: {
      //           dataLabels: { value: { fontSize: '18px' } },
      //           hollow: { size: '70%' }
      //         }
      //       }
      //     }
      //   },
      //   {
      //     breakpoint: 960,
      //     options: {
      //       chart: { height: 250 },
      //       plotOptions: {
      //         radialBar: {
      //           hollow: { size: '70%' },
      //           dataLabels: { value: { fontSize: '18px' } }
      //         }
      //       }
      //     }
      //   }
      // ]
    },
    series: [76]
  },

  radarChart: {
    series: [
      {
        name: 'iPhone 11',
        data: [41, 64, 81, 60, 42, 42, 33, 23]
      },
      {
        name: 'Samsung s20',
        data: [65, 46, 42, 25, 58, 63, 76, 43]
      }
    ],
    chartOptions: {
      chart: {
        toolbar: {
          show: false
        },
        dropShadow: {
          enabled: false,
          blur: 8,
          left: 1,
          top: 1,
          opacity: 0.2
        }
      },
      legend: {
        show: true,
        fontSize: '14px',
        fontFamily: 'Montserrat'
      },
      yaxis: {
        show: false
      },
      colors: [chartColors.donut.series1, chartColors.donut.series3],
      xaxis: {
        categories: ['Battery', 'Brand', 'Camera', 'Memory', 'Storage', 'Display', 'OS', 'Price']
      },
      fill: {
        opacity: [1, 0.8]
      },
      stroke: {
        show: false,
        width: 0
      },
      markers: {
        size: 0
      },
      grid: {
        show: false
      }
    }
  }
}
